import { IMAGE_OPTIMIZER_HOSTS, PRODUCT_IMAGE_CDN_HOSTS } from "./constants";

export function isOwnedImageUrl(url: URL, hosts: readonly string[]): boolean {
  return (
    url.protocol === "https:" &&
    hosts.includes(url.hostname) &&
    !url.username &&
    !url.password &&
    (!url.port || url.port === "443")
  );
}

export function normalizeSourcePath(sourcePath: string): string | null {
  const stripped = sourcePath.trim().replace(/^\/+/, "").replace(/\/+$/, "");
  if (!stripped || /[\x00-\x1f\x7f\\]/.test(stripped)) return null;
  if (stripped.split("/").some((part) => !part || part === "." || part === "..")) return null;
  return stripped;
}

export function imageSourcePath(source: string, sourceCdnHost: string): string | null {
  try {
    if (/[\x00-\x1f\x7f\\]/.test(source)) return null;
    const url = new URL(source);
    // Inspect the raw path before URL parsing can erase dot segments. Decode
    // once to match Cloud Run's path parameter and the existing client route.
    const rawPath = source.match(/^[a-z][a-z\d+.-]*:\/\/[^/?#]*(\/[^?#]*)/i)?.[1];
    if (!rawPath || rawPath.startsWith("//")) return null;
    const path = decodeURIComponent(rawPath);
    if (!normalizeSourcePath(path)) return null;
    if (
      isOwnedImageUrl(url, PRODUCT_IMAGE_CDN_HOSTS) &&
      PRODUCT_IMAGE_CDN_HOSTS.includes(sourceCdnHost)
    ) {
      return normalizeSourcePath(path);
    }
    if (isOwnedImageUrl(url, IMAGE_OPTIMIZER_HOSTS) && path.startsWith("/images/")) {
      const parts = path.split("/");
      if (!parts[2] || !/^w\d+-q\d+\.(?:avif|webp|jpe?g)$/.test(parts[3] ?? "")) return null;
      return normalizeSourcePath(parts.slice(4).join("/"));
    }
  } catch {
    /* Invalid URLs and malformed path encodings are ineligible. */
  }
  return null;
}
